import { Injectable } from '@angular/core';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'LedgerEntry';
const ENDPOINT = `/ledger-entries/`;
const NAVIGATIONS: NavigationParam[] = [];
const ROUTES: RouteParam[] = [];

@Injectable({
    providedIn: 'root'
})
export class LedgerEntryService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }
}